import { ROUTES } from '../constants/routes'

export const resumeRedirectRouter = (redirectionStepCode: string) =>
  ({
    '10': ROUTES.base,
    '20': ROUTES.simulationResult,
    '30': ROUTES.ownerData,
    '50': ROUTES.summaryConditions,
    '70': ROUTES.confirmation,
    '71': ROUTES.confirmation,
    '72': ROUTES.confirmation,
    '73': ROUTES.confirmation,
  }[redirectionStepCode || '10'])

export const resumeStep = (redirectionStepCode: string) =>
  ({
    '10': 1,
    '20': 2,
    '30': 3,
    '50': 5,
    '70': 7,
    '71': 7,
    '72': 7,
    '73': 7,
  }[redirectionStepCode || '10'])
